import React, { useCallback } from 'react';

import { IFundRaisingSettings } from '@model';
import { CartLayout } from '@sharedComponents/Layout';
import { GridDivider } from '@sharedComponents/Separators';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';
import { CypressTestNamespace } from '@utils/test';

import { IToggleFundRaisingAction } from '../../../context';
import { IFundRaising } from '../../../model';
import { getFundRaisingModel } from '../utils';

import { BodyColumn, IconColumn, InfoColumn, PriceColumn } from './componentsHelpers';

interface IFundRaisingServiceProps {
  settings: IFundRaisingSettings;
  onClick: (item: IToggleFundRaisingAction) => void;
  fundRaisingService?: IFundRaising | null;
  isDualPriceLayout: boolean;
}

export const FundRaisingService: ReactFCV<IFundRaisingServiceProps> = React.memo(
  ({ settings, onClick, fundRaisingService, isDualPriceLayout }) => {
    const model = getFundRaisingModel(settings, fundRaisingService);
    const onClickAction = useCallback(() => onClick({ active: !fundRaisingService }), [onClick, fundRaisingService]);

    if (model.disabled) {
      return null;
    }

    return (
      <>
        <GridDivider color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />
        <CartLayout
          data-testid="fund-raising-service-cart-layout"
          serviceActive={model.checked}
          serviceDisabled={model.disabled}
          iconColumn={IconColumn(onClickAction)}
          bodyColumn={BodyColumn(settings, onClickAction)}
          priceColumn={PriceColumn(model, isDualPriceLayout)}
          infoColumn={InfoColumn(model, onClickAction)}
          className={CypressTestNamespace.ECartPageServices.FUND_RAISING}
        />
      </>
    );
  },
);
